module.exports = __webpack_public_path__ + "static/media/ic_folder_default.967c1712.svg";